<div id="fixedtabdevmobile" class="fixed-tab-div navigation-main">
    <div class="nav-pills fixed-tabs">
        @for (item of fixedNavItems(); track item.id) {
            @if (item.condition) {
                <div class="pill-item" (click)="item.clickHandler()" (keyup)="item.clickHandler()">
                    <cc-pill-item [config]="config()" [item]="item" [iconName]="item.icon" [currentTheme]="currentTheme()"> </cc-pill-item>
                </div>
            }
        }
    </div>
</div>
